export type GcuRange = [start: string, end: string];

export const generateRange = ([start, end]: GcuRange): number[] => {
  const result = [];
  for (let i = parseInt(start, 10); i <= parseInt(end, 10); i++) {
    result.push(i);
  }
  return result;
};
